import React from "react";

/** Avoid global `.list-table .tag` (red) — use courier-only chip classes. */
const CourierBooleanTag = ({ value, trueLabel = "Yes", falseLabel = "No" }) => (
  <span
    className={`courier-status-chip ${value ? "courier-status-chip--on" : "courier-status-chip--off"}`}
  >
    {value ? trueLabel : falseLabel}
  </span>
);

export default CourierBooleanTag;
